import React from "react";
import {DatePicker, DateTimePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFnsV2";

const normalizeDate = (value) => value || null;

const pickerTextFieldProps = ({inputVariant, style, margin, label, size}) => ({
	variant: inputVariant || "outlined",
	fullWidth: true,
	margin,
	label,
	size,
	style,
});

export const KeyboardDatePickerCompat = ({
	value,
	onChange,
	format = "dd/MM/yyyy",
	inputVariant,
	style,
	margin,
	label,
	size = "medium",
	disabled,
	maxDate,
	minDate,
	locale,
	clearable,
	showTodayButton,
	todayLabel,
	cancelLabel,
	invalidDateMessage,
	maxDateMessage,
	minDateMessage,
	keyboardIcon,
	KeyboardButtonProps,
	...props
}) => (
	<LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
		<DatePicker
			value={normalizeDate(value)}
			onChange={onChange}
			format={format}
			disabled={disabled}
			maxDate={maxDate}
			minDate={minDate}
			slotProps={{
				textField: pickerTextFieldProps({inputVariant, style, margin, label, size}),
			}}
			{...props}
		/>
	</LocalizationProvider>
);

export const KeyboardDateTimePickerCompat = ({
	value,
	onChange,
	format = "dd/MM/yyyy HH:mm",
	inputVariant,
	style,
	margin,
	label,
	size = "medium",
	disabled,
	maxDate,
	minDate,
	locale,
	ampm = false,
	clearable,
	showTodayButton,
	todayLabel,
	cancelLabel,
	invalidDateMessage,
	maxDateMessage,
	minDateMessage,
	keyboardIcon,
	KeyboardButtonProps,
	...props
}) => (
	<LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
		<DateTimePicker
			value={normalizeDate(value)}
			onChange={onChange}
			format={format}
			disabled={disabled}
			maxDate={maxDate}
			minDate={minDate}
			ampm={ampm}
			slotProps={{
				textField: pickerTextFieldProps({inputVariant, style, margin, label, size}),
			}}
			{...props}
		/>
	</LocalizationProvider>
);
